var React = require('react');

function OpenSource (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M54.8343 0H35.6457L26 16.6504L35.6457 33.4035H54.8343L64.48 16.6504L54.8343 0Z","fill":"#0087FF","key":0}),React.createElement("path",{"d":"M25.5 56C38.4787 56 49 45.4787 49 32.5C49 19.5213 38.4787 9 25.5 9C12.5213 9 2 19.5213 2 32.5C2 45.4787 12.5213 56 25.5 56Z","stroke":"white","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M25.4992 39.5501C29.3928 39.5501 32.5492 36.3937 32.5492 32.5001C32.5492 28.6065 29.3928 25.4501 25.4992 25.4501C21.6056 25.4501 18.4492 28.6065 18.4492 32.5001C18.4492 36.3937 21.6056 39.5501 25.4992 39.5501Z","stroke":"white","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

OpenSource.defaultProps = {"width":"65","height":"58","viewBox":"0 0 65 58","fill":"none"};

module.exports = OpenSource;

OpenSource.default = OpenSource;
